import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const CelticArch = {
  id: "138",
  name: "Celtic Arch",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Celtic_Arch",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Celtic_Arch',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.HEAVY_INFANTRY_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        1.00, 1.00, 1.25, 1.25, 1.50, 1.50, 1.75, 1.75, 2.00, 2.00,
        2.25, 2.25, 2.50, 2.50, 2.75, 2.75, 3.00, 3.00, 3.25, 3.25,
        3.50, 3.50, 3.75, 3.75, 4.00, 4.00, 4.25, 4.25, 4.50, 4.50,
        4.75, 4.75, 5.00, 5.00, 5.25, 5.25, 5.50, 5.50, 5.75, 5.75,
        6.00, 6.00, 6.25, 6.25, 6.50, 6.50, 6.75, 6.75, 7.00, 7.00,
        7.25, 7.25, 7.50, 7.50, 7.75, 7.75, 8.00, 8.00, 8.25, 8.25,
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          43,46,49,52,55,58,61,64,67,70,73,76,79,82,85,88,91,94,97,100,103,106,109,112,115,118,121,124,127,130,133,136,139,142,145,148,151,154,157,160,163,166,169,172,175,178,181,184,187,190,193,196,199,202,205,208,211,214,217,220
        ],
        bronzeAge: [
          43,46,49,52,55,58,61,64,67,70,73,76,79,82,85,88,91,94,97,100,103,106,109,112,115,118,121,124,127,130,133,136,139,142,145,148,151,154,157,160,163,166,169,172,175,178,181,184,187,190,193,196,199,202,205,208,211,214,217,220
        ],
        minoanEra: [
          53,57,60,64,67,71,74,78,81,85,88,92,95,99,102,106,109,113,116,120,123,127,130,134,137,141,144,148,151,155,158,162,165,169,172,176,179,183,186,190,193,197,200,204,207,211,214,218,221,225,228,232,235,239,242,246,249,253,256,260
        ],
        classicGreece: [
          64,68,72,76,80,84,88,92,96,100,104,108,112,116,120,124,128,132,136,140,144,148,152,156,160,164,168,172,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264,268,272,276,280,284,288,292,296,300
        ],
        earlyRome: [
          74,79,83,88,92,97,101,106,110,115,119,124,128,133,137,142,146,151,155,160,164,169,173,178,182,187,191,196,200,205,209,214,218,223,227,232,236,241,245,250,254,259,263,268,272,277,281,286,290,295,299,304,308,313,317,322,326,331,335,340
        ],
        romanEmpire: [
          85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ],
        byzantineEra: [
          85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ],
        ageOfTheFranks: [
          90,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ],
        feudalAge: [
          85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ],
        iberianEra: [
          85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ],
        kingdomOfSicily: [
          85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ],
        highMiddleAges: [
          85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ],
        earlyGothicEra: [
          85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ],
        lateGothicEra: [
          85,90,95,100,105,110,115,120,125,130,135,140,145,150,155,160,165,170,175,180,185,190,195,200,205,210,215,220,225,230,235,240,245,250,255,260,265,270,275,280,285,290,295,300,305,310,315,320,325,330,335,340,345,350,355,360,365,370,375,380
        ]
      }).withOutput(ProductionOutputType.ALL_PREVIOUS_ERA_GOODS),
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          96,102,108,114,120,126,132,138,144,150,156,162,168,174,180,186,192,198,204,210,216,222,228,234,240,246,252,258,264,270,276,282,288,294,300,306,312,318,324,330,336,342,348,354,360,366,372,378,384,390,396,402,408,414,420,426,432,438,444,450
        ],
        bronzeAge: [
          112,119,126,133,140,147,154,161,168,175,182,189,196,203,210,217,224,231,238,245,252,259,266,273,280,287,294,301,308,315,322,329,336,343,350,357,364,371,378,385,392,399,406,413,420,427,434,441,448,455,462,469,476,483,490,497,504,511,518,525
        ],
        minoanEra: [
          128,136,144,152,160,168,176,184,192,200,208,216,224,232,240,248,256,264,272,280,288,296,304,312,320,328,336,344,352,360,368,376,384,392,400,408,416,424,432,440,448,456,464,472,480,488,496,504,512,520,528,536,544,552,560,568,576,584,592,600
        ],
        classicGreece: [
          144,153,162,171,180,189,198,207,216,225,234,243,252,261,270,279,288,297,306,315,324,333,342,351,360,369,378,387,396,405,414,423,432,441,450,459,468,477,486,495,504,513,522,531,540,549,558,567,576,585,594,603,612,621,630,639,648,657,666,675
        ],
        earlyRome: [
          160,170,180,190,200,210,220,230,240,250,260,270,280,290,300,310,320,330,340,350,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560,570,580,590,600,610,620,630,640,650,660,670,680,690,700,710,720,730,740,750
        ],
        romanEmpire: [
          176,187,198,209,220,231,242,253,264,275,286,297,308,319,330,341,352,363,374,385,396,407,418,429,440,451,462,473,484,495,506,517,528,539,550,561,572,583,594,605,616,627,638,649,660,671,682,693,704,715,726,737,748,759,770,781,792,803,814,825
        ],
        byzantineEra: [
          192,204,216,228,240,252,264,276,288,300,312,324,336,348,360,372,384,396,408,420,432,444,456,468,480,492,504,516,528,540,552,564,576,588,600,612,624,636,648,660,672,684,696,708,720,732,744,756,768,780,792,804,816,828,840,852,864,876,888,900
        ],
        ageOfTheFranks: [
          208,221,234,247,260,273,286,299,312,325,338,351,364,377,390,403,416,429,442,455,468,481,494,507,520,533,546,559,572,585,598,611,624,637,650,663,676,689,702,715,728,741,754,767,780,793,806,819,832,845,858,871,884,897,910,923,936,949,962,975
        ],
        feudalAge: [
          224,238,252,266,280,294,308,322,336,350,364,378,392,406,420,434,448,462,476,490,504,518,532,546,560,574,588,602,616,630,644,658,672,686,700,714,728,742,756,770,784,798,812,826,840,854,868,882,896,910,924,938,952,966,980,994,1008,1022,1036,1050
        ],
        iberianEra: [
          240,255,270,285,300,315,330,345,360,375,390,405,420,435,450,465,480,495,510,525,540,555,570,585,600,615,630,645,660,675,690,705,720,735,750,765,780,795,810,825,840,855,870,885,900,915,930,945,960,975,990,1005,1020,1035,1050,1065,1080,1095,1110,1125
        ],
        kingdomOfSicily: [
          256,272,288,304,320,336,352,368,384,400,416,432,448,464,480,496,512,528,544,560,576,592,608,624,640,656,672,688,704,720,736,752,768,784,800,816,832,848,864,880,896,912,928,944,960,976,992,1008,1024,1040,1056,1072,1088,1104,1120,1136,1152,1168,1184,1200
        ],
        highMiddleAges: [
          272,289,306,323,340,357,374,391,408,425,442,459,476,493,510,527,544,561,578,595,612,629,646,663,680,697,714,731,748,765,782,799,816,833,850,867,884,901,918,935,952,969,986,1003,1020,1037,1054,1071,1088,1105,1122,1139,1156,1173,1190,1207,1224,1241,1258,1275
        ],
        earlyGothicEra: [
          288,306,324,342,360,378,396,414,432,450,468,486,504,522,540,558,576,594,612,630,648,666,684,702,720,738,756,774,792,810,828,846,864,882,900,918,936,954,972,990,1008,1026,1044,1062,1080,1098,1116,1134,1152,1170,1188,1206,1224,1242,1260,1278,1296,1314,1332,1350
        ],
        lateGothicEra: [
          304,323,342,361,380,399,418,437,456,475,494,513,532,551,570,589,608,627,646,665,684,703,722,741,760,779,798,817,836,855,874,893,912,931,950,969,988,1007,1026,1045,1064,1083,1102,1121,1140,1159,1178,1197,1216,1235,1254,1273,1292,1311,1330,1349,1368,1387,1406,1425
        ]
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        4,
      ]),
    ),
  ])
};

export default CelticArch;
